import { useQueryClient } from 'react-query';
import request from '../../helpers/request';
import { queryKeys } from '../queryKeys';
import { withCancelToken } from '../helpers/withCancelToken';
import { useCallback } from 'react';

const fetcher = ({ addressId, commentId, fileName }, source) => {
  return request.get(
    `/HousingStock/address/${addressId}/comment_v2/attachment?commentId=${commentId}&fileName=${fileName}`,
    undefined,
    'При загрузке вложения произошла ошибка',
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token }
  );
};

const cancelableFetcher = (params) => {
  return withCancelToken((source) => fetcher(params, source));
};

const useFetchFlatCommentAttachment = (addressId) => {
  const queryClient = useQueryClient();

  return useCallback(
    async ({ commentId, fileName }, options) => {
      const params = { addressId, commentId, fileName };

      return await queryClient.fetchQuery(
        queryKeys.flatCommentAttachment(params),
        () => cancelableFetcher(params),
        {
          staleTime: Infinity,
          ...options,
        }
      );
    },
    [addressId, queryClient]
  );
};

export { useFetchFlatCommentAttachment };
